import React from "react";
import {
  LightButton,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeaderWithTitleAndClose,
  PrimaryButton
} from "best-common-react";
import styled from "styled-components";
import { inject, observer } from "mobx-react";

const ConfirmMessage = styled.div.attrs({ className: "mb-3" })`
  font-size: 1.125rem;
  font-weight: 300;
`;

function DeleteTempSectionModal(props) {
  return (
    <Modal show={props.show} size="lg" onClose={props.onClose}>
      <ModalHeaderWithTitleAndClose
        title="Delete Game-Specific Section"
        onClose={props.onClose}
        close={props.onClose}
      />
      <ModalBody>
        <ConfirmMessage>Are you sure you want to delete this game-specific section?</ConfirmMessage>
      </ModalBody>
      <ModalFooter>
        <div>
          <PrimaryButton className="mr-2" onClick={props.onDelete} disabled={false}>
            Delete
          </PrimaryButton>
          <LightButton onClick={props.onClose}>Cancel</LightButton>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default inject("rootStore")(observer(DeleteTempSectionModal));
